import { Layout } from "antd";
import { ReactElement } from "react";
import { AppContent } from "./content/AppContent";
import { AppFooter } from "./footer/AppFooter";
import { AppHeader } from "./header/AppHeader";
import s from "./PublicLayout.module.scss";

// Shell delle rotte pubbliche (login, callback, dispatcher, forbidden, 404).
// Usa la AppHeader condivisa SENZA item: solo la barra brandizzata, come
// pre-split, quando queste pagine vivevano dentro AppLayout.
export function PublicLayout(): ReactElement {
  return (
    <Layout className={s.layout}>
      <AppHeader />
      <AppContent />
      <AppFooter />
    </Layout>
  );
}
